import { Erc20Token } from '.'

export const PolygonMubi: Erc20Token = {
  symbol: 'MUBI',
  decimal: 18,
  address: '0xB1A91036e4a3C144efeD953e0b6CC5f6B98AD256',
}
export const PolygonOrdi: Erc20Token = {
  symbol: 'ordi',
  decimal: 18,
  address: '0x400D64732cF7dCE7B8DE899FdB2F5CFf7045F9e6',
}
export const PolygonRats: Erc20Token = {
  symbol: 'rats',
  decimal: 18,
  address: '0x745B5566135e2bF23C9094B89d482D7dA11496a2',
}

export const EthNhub: Erc20Token = {
  symbol: 'NHUB',
  decimal: 18,
  address: '0xB259fcF928e58E39D381704d3cAe9B8e969814A0',
}

// fake
export const FakeGoerliNhub: Erc20Token = {
  symbol: 'NHUB',
  decimal: 18,
  address: '0xB259fcF928e58E39D381704d3cAe9B8e969814A0',
}

export const EthBssb: Erc20Token = {
  symbol: 'BSSB',
  decimal: 18,
  address: '0xda31D0d1Bc934fC34F7189E38A413ca0A5e8b44F',
}

export const EthDaii: Erc20Token = {
  symbol: 'DAII',
  decimal: 18,
  address: '0x1981E32C2154936741aB6541a737b87C68F13cE1',
}

export const EthDova: Erc20Token = {
  symbol: 'DOVA',
  decimal: 18,
  address: '0x06A4385d11b64Be7248db210ECa0A04A558608A5',
}
